// Import question configs and vocabulary data for each lesson

import {
    unit1Lesson1ComposeSentenceConfigs,
    unit1Lesson1FillInBlankConfigs,
    unit1Lesson1MatchingWordsConfig,
    unit1Lesson1VocabIntroConfigs,
    unit1Lesson1WordTranslationConfigs
} from '../questions/unit1/unit1Lesson1QuestionConfigs.ts';
import { unit1Lesson1ExtendedWordBank } from '../questions/unit1/unit1Lesson1VocabularyData.ts';

import {
    unit1Lesson2ComposeSentenceConfigs,
    unit1Lesson2FillInBlankConfigs,
    unit1Lesson2MatchingWordsConfig,
    unit1Lesson2VocabIntroConfigs,
    unit1Lesson2WordTranslationConfigs
} from '../questions/unit1/unit1Lesson2QuestionConfigs.ts';
import { unit1Lesson2ExtendedWordBank } from '../questions/unit1/unit1Lesson2VocabularyData.ts';

import {
    unit1Lesson3ComposeSentenceConfigs,
    unit1Lesson3FillInBlankConfigs,
    unit1Lesson3MatchingWordsConfig,
    unit1Lesson3VocabIntroConfigs,
    unit1Lesson3WordTranslationConfigs
} from '../questions/unit1/unit1Lesson3QuestionConfigs.ts';
import { unit1Lesson3ExtendedWordBank } from '../questions/unit1/unit1Lesson3VocabularyData.ts';

import {
    unit1Lesson4ComposeSentenceConfigs,
    unit1Lesson4FillInBlankConfigs,
    unit1Lesson4MatchingWordsConfig,
    unit1Lesson4VocabIntroConfigs,
    unit1Lesson4WordTranslationConfigs
} from '../questions/unit1/unit1Lesson4QuestionConfigs.ts';
import { unit1Lesson4ExtendedWordBank } from '../questions/unit1/unit1Lesson4VocabularyData.ts';

import {
    unit1Lesson5ComposeSentenceConfigs,
    unit1Lesson5FillInBlankConfigs,
    unit1Lesson5MatchingWordsConfig,
    unit1Lesson5VocabIntroConfigs,
    unit1Lesson5WordTranslationConfigs
} from '../questions/unit1/unit1Lesson5QuestionConfigs.ts';
import { unit1Lesson5ExtendedWordBank } from '../questions/unit1/unit1Lesson5VocabularyData.ts';

import {
    unit5Lesson1ComposeSentenceConfigs,
    unit5Lesson1FillInBlankConfigs,
    unit5Lesson1MatchingWordsConfig,
    unit5Lesson1VocabIntroConfigs,
    unit5Lesson1WordTranslationConfigs
} from '../questions/unit5/unit5Lesson1QuestionConfigs.ts';
import { unit5Lesson1ExtendedWordBank } from '../questions/unit5/unit5Lesson1VocabularyData.ts';

import {
    unit5Lesson2ComposeSentenceConfigs,
    unit5Lesson2FillInBlankConfigs,
    unit5Lesson2MatchingWordsConfig,
    unit5Lesson2VocabIntroConfigs,
    unit5Lesson2WordTranslationConfigs
} from '../questions/unit5/unit5Lesson2QuestionConfigs.ts';
import { unit5Lesson2ExtendedWordBank } from '../questions/unit5/unit5Lesson2VocabularyData.ts';

import {
    unit5Lesson3ComposeSentenceConfigs,
    unit5Lesson3FillInBlankConfigs,
    unit5Lesson3MatchingWordsConfig,
    unit5Lesson3VocabIntroConfigs,
    unit5Lesson3WordTranslationConfigs
} from '../questions/unit5/unit5Lesson3QuestionConfigs.ts';
import { unit5Lesson3ExtendedWordBank } from '../questions/unit5/unit5Lesson3VocabularyData.ts';

// Utility function to randomize questions while keeping VocabIntroConfigs first
function randomizeQuestions(vocabIntroConfigs: any[], otherQuestions: any[]): any[] {
    // Shuffle the other questions (everything except vocab intro)
    const shuffledOtherQuestions = [...otherQuestions].sort(() => Math.random() - 0.5);

    // Return vocab intro configs first, then randomized other questions
    return [...vocabIntroConfigs, ...shuffledOtherQuestions];
}

// // Unit 2 imports
// import {
//     unit2Lesson1ComposeSentenceConfigs,
//     unit2Lesson1FillInBlankConfigs,
//     unit2Lesson1MatchingWordsConfig,
//     unit2Lesson1VocabIntroConfigs,
//     unit2Lesson1WordTranslationConfigs
// } from '../questions/unit2/unit2Lesson1QuestionConfigs.ts';
// import { unit2Lesson1ExtendedWordBank } from '../questions/unit2/unit2Lesson1VocabularyData.ts';

// import {
//     unit2Lesson2ComposeSentenceConfigs,
//     unit2Lesson2FillInBlankConfigs,
//     unit2Lesson2MatchingWordsConfig,
//     unit2Lesson2VocabIntroConfigs,
//     unit2Lesson2WordTranslationConfigs
// } from '../questions/unit2/unit2Lesson2QuestionConfigs.ts';
// import { unit2Lesson2ExtendedWordBank } from '../questions/unit2/unit2Lesson2VocabularyData.ts';

// import {
//     unit2Lesson3ComposeSentenceConfigs,
//     unit2Lesson3FillInBlankConfigs,
//     unit2Lesson3VocabIntroConfigs,
//     unit2Lesson3WordMatchingPairs,
//     unit2Lesson3WordTranslationConfigs
// } from '../questions/unit2/unit2Lesson3QuestionConfigs.ts';
// import { unit2Lesson3ExtendedWordBank } from '../questions/unit2/unit2Lesson3VocabularyData.ts';

// import {
//     unit2Lesson4ComposeSentenceConfigs,
//     unit2Lesson4FillInBlankConfigs,
//     unit2Lesson4VocabIntroConfigs,
//     unit2Lesson4WordMatchingPairs,
//     unit2Lesson4WordTranslationConfigs
// } from '../questions/unit2/unit2Lesson4QuestionConfigs.ts';
// import { unit2Lesson4ExtendedWordBank } from '../questions/unit2/unit2Lesson4VocabularyData.ts';

// import {
//     unit2Lesson5ComposeSentenceConfigs,
//     unit2Lesson5FillInBlankConfigs,
//     unit2Lesson5VocabIntroConfigs,
//     unit2Lesson5WordMatchingPairs,
//     unit2Lesson5WordTranslationConfigs
// } from '../questions/unit2/unit2Lesson5QuestionConfigs.ts';
// import { unit2Lesson5ExtendedWordBank } from '../questions/unit2/unit2Lesson5VocabularyData.ts';

// // Unit 3 imports
// import {
//     unit3Lesson1ComposeSentenceConfigs,
//     unit3Lesson1FillInBlankConfigs,
//     unit3Lesson1VocabIntroConfigs,
//     unit3Lesson1WordMatchingPairs,
//     unit3Lesson1WordTranslationConfigs
// } from '../questions/unit3/unit3Lesson1QuestionConfigs.ts';
// import { unit3Lesson1ExtendedWordBank } from '../questions/unit3/unit3Lesson1VocabularyData.ts';

// import {
//     unit3Lesson2ComposeSentenceConfigs,
//     unit3Lesson2FillInBlankConfigs,
//     unit3Lesson2VocabIntroConfigs,
//     unit3Lesson2WordMatchingPairs,
//     unit3Lesson2WordTranslationConfigs
// } from '../questions/unit3/unit3Lesson2QuestionConfigs.ts';
// import { unit3Lesson2ExtendedWordBank } from '../questions/unit3/unit3Lesson2VocabularyData.ts';

// import {
//     unit3Lesson3ComposeSentenceConfigs,
//     unit3Lesson3FillInBlankConfigs,
//     unit3Lesson3VocabIntroConfigs,
//     unit3Lesson3WordMatchingPairs,
//     unit3Lesson3WordTranslationConfigs
// } from '../questions/unit3/unit3Lesson3QuestionConfigs.ts';
// import { unit3Lesson3ExtendedWordBank } from '../questions/unit3/unit3Lesson3VocabularyData.ts';

// import {
//     unit3Lesson4ComposeSentenceConfigs,
//     unit3Lesson4FillInBlankConfigs,
//     unit3Lesson4VocabIntroConfigs,
//     unit3Lesson4WordMatchingPairs,
//     unit3Lesson4WordTranslationConfigs
// } from '../questions/unit3/unit3Lesson4QuestionConfigs.ts';
// import { unit3Lesson4ExtendedWordBank } from '../questions/unit3/unit3Lesson4VocabularyData.ts';

// import {
//     unit3Lesson5ComposeSentenceConfigs,
//     unit3Lesson5FillInBlankConfigs,
//     unit3Lesson5VocabIntroConfigs,
//     unit3Lesson5WordMatchingPairs,
//     unit3Lesson5WordTranslationConfigs
// } from '../questions/unit3/unit3Lesson5QuestionConfigs.ts';
// import { unit3Lesson5ExtendedWordBank } from '../questions/unit3/unit3Lesson5VocabularyData.ts';

// import {
//     unit4Lesson1ComposeSentenceConfigs,
//     unit4Lesson1FillInBlankConfigs,
//     unit4Lesson1MatchingWordsConfig,
//     unit4Lesson1VocabIntroConfigs,
//     unit4Lesson1WordTranslationConfigs
// } from '../questions/unit4/unit4Lesson1QuestionConfigs.ts';
// import { unit4Lesson1ExtendedWordBank } from '../questions/unit4/unit4Lesson1VocabularyData.ts';

export interface Lesson {
    id: string; // Unique lesson identifier
    type: "regular" | "practice" | "final";
    lessonTitle: string;
    lessonDescription: string;
    lessonDataId?: number; // Reference to detailed lesson data
    questions?: any[]; // Question configurations for this lesson
    vocab?: any[]; // Vocabulary data for this lesson
}

export interface Unit {
    id: string; // Unique unit identifier
    title: string;
    colorClassName: string;
    lessons: Lesson[];
    unitDataId?: number; // Reference to detailed unit data
}

export const unitsData: Unit[] = [
    {
        id: "unit-1",
        title: "Perkenalan Diri",
        colorClassName: "bg-red-500",
        unitDataId: 1, // References unit1Data
        lessons: [
            {
                id: "lesson-1-1",
                type: "regular",
                lessonTitle: "Menyebutkan Nama dan Sapaan",
                lessonDescription: "Pelajari cara memperkenalkan diri dan menyapa dalam bahasa Batak",
                lessonDataId: 1,
                questions: randomizeQuestions(
                    unit1Lesson1VocabIntroConfigs,
                    [
                        ...unit1Lesson1WordTranslationConfigs,
                        ...unit1Lesson1FillInBlankConfigs,
                        unit1Lesson1MatchingWordsConfig,
                        ...unit1Lesson1ComposeSentenceConfigs
                    ]
                ),
                vocab: unit1Lesson1ExtendedWordBank
            },
            {
                id: "lesson-1-2",
                type: "regular",
                lessonTitle: "Menyebutkan Asal",
                lessonDescription: "Pelajari cara menyatakan asal daerah dan menanyakan asal orang lain",
                lessonDataId: 2,
                questions: randomizeQuestions(
                    unit1Lesson2VocabIntroConfigs,
                    [
                        ...unit1Lesson2WordTranslationConfigs,
                        ...unit1Lesson2FillInBlankConfigs,
                        unit1Lesson2MatchingWordsConfig,
                        ...unit1Lesson2ComposeSentenceConfigs
                    ]
                ),
                vocab: unit1Lesson2ExtendedWordBank
            },
            {
                id: "lesson-1-3",
                type: "regular",
                lessonTitle: "Umur dan Pekerjaan",
                lessonDescription: "Pelajari cara menyatakan umur dan pekerjaan dalam bahasa Batak",
                lessonDataId: 3,
                questions: randomizeQuestions(
                    unit1Lesson3VocabIntroConfigs,
                    [
                        ...unit1Lesson3WordTranslationConfigs,
                        ...unit1Lesson3FillInBlankConfigs,
                        unit1Lesson3MatchingWordsConfig,
                        ...unit1Lesson3ComposeSentenceConfigs
                    ]
                ),
                vocab: unit1Lesson3ExtendedWordBank
            },
            {
                id: "lesson-1-4",
                type: "regular",
                lessonTitle: "Kata Ganti & Kalimat Dasar",
                lessonDescription: "Pelajari kata ganti orang dan struktur kalimat dasar",
                lessonDataId: 4,
                questions: randomizeQuestions(
                    unit1Lesson4VocabIntroConfigs,
                    [
                        ...unit1Lesson4WordTranslationConfigs,
                        ...unit1Lesson4FillInBlankConfigs,
                        unit1Lesson4MatchingWordsConfig,
                        ...unit1Lesson4ComposeSentenceConfigs
                    ]
                ),
                vocab: unit1Lesson4ExtendedWordBank
            },
            {
                id: "lesson-1-5",
                type: "final",
                lessonTitle: "Rekap dan Percakapan Pendek",
                lessonDescription: "Menggabungkan semua materi untuk percakapan lengkap dan review komprehensif",
                lessonDataId: 5,
                questions: randomizeQuestions(
                    unit1Lesson5VocabIntroConfigs,
                    [
                        ...unit1Lesson5WordTranslationConfigs,
                        ...unit1Lesson5FillInBlankConfigs,
                        unit1Lesson5MatchingWordsConfig,
                        ...unit1Lesson5ComposeSentenceConfigs
                    ]
                ),
                vocab: unit1Lesson5ExtendedWordBank
            },
        ],
    },
    {
        id: "unit-2",
        title: "Keluarga",
        colorClassName: "bg-blue-500",
        unitDataId: 2,
        lessons: [
            {
                id: "lesson-2-1",
                type: "regular",
                lessonTitle: "Anggota Keluarga Inti",
                lessonDescription: "Pelajari nama-nama anggota keluarga inti dalam bahasa Batak Toba",
            },
            {
                id: "lesson-2-2",
                type: "regular",
                lessonTitle: "Panggilan dan Hubungan",
                lessonDescription: "Pelajari cara memanggil dan menyebut hubungan keluarga",
            },
            {
                id: "lesson-2-3",
                type: "regular",
                lessonTitle: "Panggilan dan Hubungan",
                lessonDescription: "Pelajari panggilan dan hubungan keluarga yang lebih kompleks",
            },
            {
                id: "lesson-2-4",
                type: "regular",
                lessonTitle: "Marga dan Kekerabatan",
                lessonDescription: "Pelajari sistem marga dan hubungan kekerabatan dalam budaya Batak",
            },
            {
                id: "lesson-2-5",
                type: "final",
                lessonTitle: "Percakapan Seputar Keluarga",
                lessonDescription: "Latihan percakapan lengkap tentang keluarga dan kekerabatan",
            },
        ],
    },
    {
        id: "unit-3",
        title: "Umur dan Pekerjaan",
        colorClassName: "bg-green-500",
        unitDataId: 3,
        lessons: [
            {
                id: "lesson-3-1",
                type: "regular",
                lessonTitle: "Umur dan Bilangan",
                lessonDescription: "Pelajari cara menyebutkan umur dan angka dalam bahasa Batak",
            },
            {
                id: "lesson-3-2",
                type: "regular",
                lessonTitle: "Menyebutkan Profesi",
                lessonDescription: "Pelajari nama-nama profesi dan pekerjaan dalam bahasa Batak",
            },
            {
                id: "lesson-3-3",
                type: "regular",
                lessonTitle: "Bertanya dan Menjawab tentang Profesi",
                lessonDescription: "Pelajari cara bertanya dan menjawab tentang pekerjaan seseorang",
            },
            {
                id: "lesson-3-4",
                type: "regular",
                lessonTitle: "Profesi dalam Keluarga",
                lessonDescription: "Pelajari cara menyebutkan profesi anggota keluarga",
            },
            {
                id: "lesson-3-5",
                type: "final",
                lessonTitle: "Percakapan Singkat Umur dan Pekerjaan",
                lessonDescription: "Latihan percakapan lengkap tentang umur dan pekerjaan",
            },
        ],
    },
    {
        id: "unit-4",
        title: "Tempat Tinggal dan Lingkungan",
        colorClassName: "bg-orange-500",
        lessons: [
            {
                id: "lesson-4-1",
                type: "regular",
                lessonTitle: "Menyebutkan Tempat Tinggal",
                lessonDescription: "Pelajari nama-nama tempat tinggal dalam bahasa Batak",
            },
            {
                id: "lesson-4-2",
                type: "regular",
                lessonTitle: "Lingkungan Sekitar",
                lessonDescription: "Pelajari cara mendeskripsikan lingkungan sekitar",
            },
            {
                id: "lesson-4-3",
                type: "practice",
                lessonTitle: "Latihan Mendeskripsikan Tempat",
                lessonDescription: "Latihan untuk mendeskripsikan tempat tinggal dan lingkungan",
            },
            {
                id: "lesson-4-4",
                type: "regular",
                lessonTitle: "Arah dan Lokasi",
                lessonDescription: "Pelajari cara memberikan petunjuk arah dan lokasi",
            },
            {
                id: "lesson-4-5",
                type: "final",
                lessonTitle: "Percakapan Seputar Tempat Tinggal",
                lessonDescription: "Ujian akhir untuk menguji pemahamanmu tentang tempat tinggal dan lingkungan",
            },
        ],
    },
    {
        id: "unit-5",
        title: "Kegiatan Sehari-hari",
        colorClassName: "bg-purple-500",
        lessons: [
            {
                id: "lesson-5-1",
                type: "regular",
                lessonTitle: "Tempat Umum",
                lessonDescription: "Pelajari nama-nama tempat umum dalam bahasa Batak",
                lessonDataId: 1,
                questions: randomizeQuestions(
                    unit5Lesson1VocabIntroConfigs,
                    [
                        ...unit5Lesson1WordTranslationConfigs,
                        ...unit5Lesson1FillInBlankConfigs,
                        unit5Lesson1MatchingWordsConfig,
                        ...unit5Lesson1ComposeSentenceConfigs
                    ]
                ),
                vocab: unit5Lesson1ExtendedWordBank
            },
            {
                id: "lesson-5-2",
                type: "regular",
                lessonTitle: "Menanyakan Arah",
                lessonDescription: "Pelajari cara menanyakan dan memberikan arah",
                lessonDataId: 2,
                questions: randomizeQuestions(
                    unit5Lesson2VocabIntroConfigs,
                    [
                        ...unit5Lesson2WordTranslationConfigs,
                        ...unit5Lesson2FillInBlankConfigs,
                        unit5Lesson2MatchingWordsConfig,
                        ...unit5Lesson2ComposeSentenceConfigs
                    ]
                ),
                vocab: unit5Lesson2ExtendedWordBank
            },
            {
                id: "lesson-5-3",
                type: "practice",
                lessonTitle: "Latihan Navigasi",
                lessonDescription: "Latihan untuk navigasi dan petunjuk arah",
                lessonDataId: 3,
                questions: randomizeQuestions(
                    unit5Lesson3VocabIntroConfigs,
                    [
                        ...unit5Lesson3WordTranslationConfigs,
                        ...unit5Lesson3FillInBlankConfigs,
                        unit5Lesson3MatchingWordsConfig,
                        ...unit5Lesson3ComposeSentenceConfigs
                    ]
                ),
                vocab: unit5Lesson3ExtendedWordBank
            },
            {
                id: "lesson-5-4",
                type: "regular",
                lessonTitle: "Transportasi",
                lessonDescription: "Pelajari vocabulary tentang transportasi",
            },
            {
                id: "lesson-5-5",
                type: "final",
                lessonTitle: "Ujian Akhir",
                lessonDescription: "Ujian akhir untuk menguji pemahamanmu tentang tempat dan arah",
            },
        ],
    },
];
